<div class="card">
	<div class="card-header">
		<h1>Calendario de Órdenes de Compra</h1>
	</div>
	<div class="card-body">
		<div class="calendar-wrapper" style="display: flex;">
            <div class="calendar" style="flex: 1; overflow: auto;">
                <full-calendar [options]="calendarOptions">
                </full-calendar>
            </div>
            <div class="extra-column" style="width: 200px; border-left: 1px solid #ccc;">
                <div *ngFor="let week of detailsForWeek" class="extra-row cursor-pointer calendar-cell">
                    <div class="d-flex flex-col">
                        {{ week.label }}
                        <span class="date-label">{{ week.startDate | date:'dd/MM' }} - {{ week.endDate | date:'dd/MM' }}</span>
                    </div>
                    <!-- <span>
                        <i class="fa fa-box-open"></i>
                    </span> -->
                    <div class="d-flex flex-col events">
                        <ng-container *ngFor="let item of week.purchaseDetails | slice:0:maxEvents">
                            <span class="fc-daygrid-event event" (click)="openModalInfoOrderForDay(item, week.startDate, week.endDate)">
                                {{item.productName}}: {{item.totalQuantity}}
                            </span>
                        </ng-container>
                        <div 
                            class="more-events" 
                            *ngIf="week.purchaseDetails.length > maxEvents"
                            (click)="openPopup(week.purchaseDetails, week.startDate, week.endDate)">
                            +{{ week.purchaseDetails.length - maxEvents }} más
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Popup -->
        <div class="popup" *ngIf="popupVisible">
            <div class="popup-content">
                <div class="modal-header p-0">
                    <h3>Órdenes</h3>
                    <button class="close-btn" (click)="closePopup()">✕</button>
                </div>
                
                <ul class="pl-0">
                    <li *ngFor="let event of popupEvents" class="fc-daygrid-event pl-0" (click)="openModalFromPopup(event)">
                        <span>{{event.productName}}: {{event.totalQuantity}}</span>
                    </li>
                </ul>
            </div>
        </div>
	</div>
</div>

<app-total-purchase-order-calendar-days 
*ngIf="showModalOrdes" 
[showModal]="showModalOrdes" 
[productId]="productId" 
[productName]="productName" 
[startDate]="startDate" 
[endDate]="endDate"
(closed)="closeModalOrders($event)"
/>